import { useEffect } from "react";

export const usePageMetadata = (title: string, description?: string, canonicalPath?: string) => {
  useEffect(() => {
    if (!title) return;
    // 1. Update browser tab title
    document.title = title;

    // 2. Update Open Graph and Twitter title tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", title);

    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute("content", title);

    // 3. Update standard, Open Graph, and Twitter description tags
    if (description) {
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute("content", description);

      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute("content", description);

      const twitterDesc = document.querySelector('meta[name="twitter:description"]');
      if (twitterDesc) twitterDesc.setAttribute("content", description);
    }

    // 4. Update Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      const path = canonicalPath || window.location.pathname;
      const url = `https://www.ezywatermark.com${path}`;
      canonical.setAttribute("href", url);

      const ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) ogUrl.setAttribute("content", url);

      const twitterUrl = document.querySelector('meta[name="twitter:url"]');
      if (twitterUrl) twitterUrl.setAttribute("content", url);
    }
  }, [title, description, canonicalPath]);
};

export default usePageMetadata;
